import { render, staticRenderFns } from "./listar-conceptos.vue?vue&type=template&id=6ce0c136"
import script from "./listar-conceptos.vue?vue&type=script&lang=js"
export * from "./listar-conceptos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports